import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import GroupIcon from "@material-ui/icons/Group";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Button from "@material-ui/core/Button";
import Skeleton from "@material-ui/lab/Skeleton";
import backgroundTansaksi from "../../../assets/images/backgroundTransaksi.png";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import currency from "./../../../utils/currency";
import useStyles from "./style";
import DialogPw from "../PencairanSaya/dialogPw";
import Gap from "../../../components/Gap";

function Transaksi() {
  const classes = useStyles();
  const history = useHistory();
  const { profil, level } = useData();
  const [transaksi, setTransaksi] = useState({});
  const [loadingTransaksi, setLoadingTransaksi] = useState(true);

  const getTotalTransaksiSeller = useCallback(async () => {
    const transaksi = firefunctions.httpsCallable("getTotalTransaksiSeller");
    const res = await transaksi({ user_id: profil.id });

    setTransaksi(res.data);
    setLoadingTransaksi(false);
  }, [profil.id]);

  useEffect(() => {
    getTotalTransaksiSeller();
  }, []);
  const [dialog, setDialog] = useState({
    open: false,
  });

  return (
    <>
      <div
        className={classes.hero}
        style={{
          backgroundImage: `url(${backgroundTansaksi})`,
        }}
      >
        <div className={classes.wrapHeader}>
          <Typography className={classes.liquidTitle}>Transaksi</Typography>
          <Gap height={5} />
          <Typography className={classes.liquidSecond}>
            Total Saldo Kredit
          </Typography>
          <Gap height={5} />
          {loadingTransaksi ? (
            <div style={{ justifyContent: "center", display: "flex" }}>
              <Skeleton width="20%" />
            </div>
          ) : (
            <Typography className={classes.liquidTitle}>
              {currency(transaksi.total_saldo_kredit)}
            </Typography>
          )}
        </div>
        <div className={classes.wrapCard}>
          <Card>
            <CardContent>
              <Grid container>
                <Grid item className={classes.wrapGrid}>
                  <div style={{ padding: 5 }}>
                    <Typography className={classes.liquidPrimaryTitle}>
                      Total Komisi
                    </Typography>
                    {loadingTransaksi ? (
                      <Skeleton variant="text" />
                    ) : (
                      <Typography className={classes.liquidSecond}>
                        {currency(transaksi.total_komisi_saya)}
                      </Typography>
                    )}
                  </div>
                  <CardActions>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      fullWidth
                      onClick={() => history.push("/transaksi/komisisaya")}
                    >
                      Komisi Saya
                    </Button>
                  </CardActions>
                </Grid>
                <Grid item className={classes.wrapGrid}>
                  <div style={{ padding: 5 }}>
                    <Typography className={classes.liquidPrimaryTitle}>
                      Total Pencairan
                    </Typography>
                    {loadingTransaksi ? (
                      <Skeleton variant="text" />
                    ) : (
                      <Typography className={classes.liquidSecond}>
                        {currency(transaksi?.total_pencairan_approved ?? 0)}
                      </Typography>
                    )}
                  </div>
                  <CardActions>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      fullWidth
                      onClick={() => history.push("/transaksi/pencairansaya")}
                    >
                      Pencairan
                    </Button>
                  </CardActions>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className={classes.wrapList}>
        <List
          subheader={
            <ListSubheader disableSticky={true}>Daftar Transaksi</ListSubheader>
          }
        >
          <ListItem
            button
            onClick={() =>
              history.push("/transaksi/transaksilist/sellerapp/tokorame")
            }
          >
            <ListItemIcon>
              <SmartphoneIcon color="inherit" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  Transaksi Via TokoRame
                </Typography>
              }
              secondary={
                <div>
                  <Typography className={classes.liquidSecondList}>
                    Total Transaksi
                  </Typography>
                  {loadingTransaksi ? (
                    <Skeleton width="40%" />
                  ) : (
                    <Typography className={classes.liquidThird}>
                      {currency(transaksi.total_transaksi_sellerapp)}
                    </Typography>
                  )}
                </div>
              }
            />

            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() =>
              history.push("/transaksi/transaksilist/webstore/webstore")
            }
          >
            <ListItemIcon>
              <LocalMallOutlinedIcon color="inherit" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  Transaksi Via Webstore
                </Typography>
              }
              secondary={
                <div className={classes.liquid}>
                  <div>
                    <Typography className={classes.liquidSecondList}>
                      Total Transaksi
                    </Typography>
                    {loadingTransaksi ? (
                      <Skeleton width="40%" />
                    ) : (
                      <Typography className={classes.liquidThird}>
                        {currency(transaksi.total_transaksi_webstore)}
                      </Typography>
                    )}
                  </div>
                  <div>
                    <Typography className={classes.liquidSecondList}>
                      Total Komisi
                    </Typography>
                    {loadingTransaksi ? (
                      <Skeleton width="40%" />
                    ) : (
                      <Typography className={classes.liquidThird}>
                        {currency(transaksi.total_komisi_webstore)}
                      </Typography>
                    )}
                  </div>
                </div>
              }
            />
            {/* <ListItemText
              secondary={
                <div className={classes.secondItem}>
                  <Typography className={classes.liquidSecondList}>
                    Total Komisi
                  </Typography>
                  {loadingTransaksi ? (
                    <Skeleton width="40%" />
                  ) : (
                    <Typography className={classes.liquidThird}>
                      {currency(transaksi.total_komisi_webstore)}
                    </Typography>
                  )}
                </div>
              }
            /> */}
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => history.push("/transaksi/jaringansaya")}
          >
            <ListItemIcon>
              <GroupIcon color="inherit" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  Team Saya
                </Typography>
              }
              secondary={
                <div className={classes.liquid}>
                  <div>
                    <Typography className={classes.liquidSecondList}>
                      Total Transaksi
                    </Typography>
                    {loadingTransaksi ? (
                      <Skeleton width="40%" />
                    ) : (
                      <Typography className={classes.liquidThird}>
                        {currency(transaksi.total_transaksi_jaringan)}
                      </Typography>
                    )}
                  </div>
                  <div>
                    <Typography className={classes.liquidSecondList}>
                      Total Komisi
                    </Typography>
                    {loadingTransaksi ? (
                      <Skeleton width="40%" />
                    ) : (
                      <Typography className={classes.liquidThird}>
                        {currency(transaksi.total_komisi_jaringan)}
                      </Typography>
                    )}
                  </div>
                </div>
              }
            />
            {/* <ListItemText
              secondary={
                <div className={classes.secondItem}>
                  <Typography className={classes.liquidSecondList}>
                    Total Komisi
                  </Typography>
                  {loadingTransaksi ? (
                    <Skeleton width="40%" />
                  ) : (
                    <Typography className={classes.liquidThird}>
                      {currency(transaksi.total_komisi_jaringan)}
                    </Typography>
                  )}
                </div>
              }
            /> */}
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/transaksi/jaringansaya")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          {level?.level === "mentorbisnis" ? (
            <>
              <ListItem
                button
                onClick={() => history.push("/transaksi/rekomendasisaya")}
              >
                <ListItemIcon>
                  <GroupAddIcon color="inherit" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography className={classes.liquidPrimary}>
                      Rekomendasi Saya
                    </Typography>
                  }
                  secondary={
                    <div>
                      <Typography className={classes.liquidSecondList}>
                        Total Transaksi
                      </Typography>
                      {loadingTransaksi ? (
                        <Skeleton width="40%" />
                      ) : (
                        <Typography className={classes.liquidThird}>
                          {currency(transaksi.total_transaksi_tim_rekomendasi)}
                        </Typography>
                      )}
                    </div>
                  }
                />
                <ListItemText
                  secondary={
                    <div className={classes.secondItem}>
                      <Typography className={classes.liquidSecondList}>
                        Total Komisi
                      </Typography>
                      {loadingTransaksi ? (
                        <Skeleton width="40%" />
                      ) : (
                        <Typography className={classes.liquidThird}>
                          {currency(transaksi.total_komisi_tim_rekomendasi)}
                        </Typography>
                      )}
                    </div>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => history.push("/transaksi/rekomendasisaya")}
                  >
                    <NavigateNextIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider />
            </>
          ) : null}
        </List>
      </div>
      <div className={classes.wrapKredit}>
        <List
          subheader={
            <ListSubheader disableSticky={true}>Pencairan Kredit</ListSubheader>
          }
        >
          <ListItem>
            <ListItemIcon>
              <CreditCardIcon color="secondary" />
            </ListItemIcon>
            <ListItemText
              secondary={
                <Typography className={classes.liquidSecond}>
                  kamu bisa mengajukan pencairan saldo kredit untuk di transfer
                  ke rekening kamu.
                </Typography>
              }
            />
          </ListItem>
          <div className={classes.wrapBtnList}>
            <Button
              variant="contained"
              onClick={(e) => {
                setDialog({ open: true });
              }}
              size="small"
              color="primary"
              fullWidth
            >
              Ajukan Pencairan Kredit
            </Button>
          </div>
        </List>
      </div>
      <DialogPw
        dialog={dialog}
        handleClose={() => {
          setDialog({ open: false });
        }}
      />
    </>
  );
}

export default Transaksi;
